// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-model {
  margin-top: 2rem;
}
.card-container {
  width: 100%;
}
.scrollModel {
  max-height: 350px;
  min-height: 350px;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 10px;
  border: none;
}
.nameModel h2 {
  margin-left: 2%;
  color: #21134f;
  font-size: 24px;
}
.cardAllModel {
  margin-top: 3%;
}
.edit {
  display: none;
}
.notShow {
  display: none;
}
.cardModel {
  max-width: 330px;
  min-height: 340px;
}
.textInput {
  background-color: transparent;
  border: 0;
}
.card-text {
  display: flex;
  width: 100% !important;
  justify-content: center !important;
  align-items: center;
  gap: 10%;
}
.left-model,
.right-model {
  width: 50%;
}
.left-model {
  float: left;
  margin-left: 5%;
}
.right-model {
  display: flex;
  float: right;
  margin-left: 31%;
}
.btn-model {
  float: right;
  margin-left: 5%;
  color: #b7b7b7;
}
.model-action {
  color: #b7b7b7;
}
.notShowInput {
  display: none;
}
.showInput {
  display: flex;
  width: 100%;
  text-align: center;
}
.newAdd {
  background-color: transparent;
  border: 0;
}
.inputModal {
  display: flex;
  margin-left: 6%;
}
.modelTag {
  border: 0;
  font-size: 15px;
  border-radius: 8px;
  width: 230px;
  height: 30px;
  text-align: center;
  padding-top: 3%;
}
.nameModel h2 {
  margin-left: 2%;
  color: #21134f;
  font-size: 20px;
}
.cardAllEdit {
  margin-top: 3%;
}
.edit {
  display: none;
}
.notShow {
  display: none;
}
.cardEdit {
  max-width: 330px;
  min-height: 340px;
}
.textInput {
  background-color: transparent;
  border: 0px;
}
.left {
  width: fit-content;
}
.right {
  display: flex;
  overflow-wrap: normal;
  margin-left: 0 !important;
}
.btn {
  float: right;
  margin-left: 5%;
  color: #989898;
}
.notShowInput {
  display: none;
}
.showInput {
  display: flex;
  width: 100%;
  text-align: center;
}
.newAdd {
  background-color: transparent;
  border: 0;
}
.editScenario {
  border: 0;
  font-size: 15px;
  border-radius: 8px;
  width: 220px;
  height: 35px;
  text-align: center;
  padding-top: 3%;
}
.scrollEditScenario {
  height: 250;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 10px;
  border: none;
}
@media screen and (max-width: 1400px) {
  .card-container > .ant-card-body {
    padding: 24px 10px 10px 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/settings/EditTable/styles/index.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AAEA;EACE,WAAA;AAAF;AAKA;EACE,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAHF;AAMA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAJF;AAMA;EACE,cAAA;AAJF;AAMA;EACE,aAAA;AAJF;AAOA;EACE,aAAA;AALF;AAQA;EACE,gBAAA;EACA,iBAAA;AANF;AASA;EACE,6BAAA;EACA,SAAA;AAPF;AAUA;EACE,aAAA;EACA,sBAAA;EACA,kCAAA;EACA,mBAAA;EACA,QAAA;AARF;AAWA;;EAEE,UAAA;AATF;AAYA;EACE,WAAA;EACA,eAAA;AAVF;AAaA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;AAXF;AAcA;EACE,YAAA;EACA,eAAA;EACA,cAAA;AAZF;AAeA;EACE,cAAA;AAbF;AAgBA;EACE,aAAA;AAdF;AAiBA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;AAfF;AAkBA;EACE,6BAAA;EACA,SAAA;AAhBF;AAmBA;EACE,aAAA;EACA,eAAA;AAjBF;AAoBA;EACE,SAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAlBF;AAqBA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAnBF;AAqBA;EACE,cAAA;AAnBF;AAqBA;EACE,aAAA;AAnBF;AAsBA;EACE,aAAA;AApBF;AAuBA;EACE,gBAAA;EACA,iBAAA;AArBF;AAwBA;EACE,6BAAA;EACA,WAAA;AAtBF;AAyBA;EACE,kBAAA;AAvBF;AA4BA;EACE,aAAA;EACA,qBAAA;EACA,yBAAA;AA1BF;AA6BA;EACE,YAAA;EACA,eAAA;EACA,cAAA;AA3BF;AA8BA;EACE,aAAA;AA5BF;AA+BA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;AA7BF;AAgCA;EACE,6BAAA;EACA,SAAA;AA9BF;AAiCA;EACE,SAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AA/BF;AAkCA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAhCF;AAmCA;EACE;IACE,4BAAA;EAjCF;AACF","sourcesContent":[".card-model {\n  margin-top: 2rem;\n}\n\n.card-container {\n  width: 100%;\n  // min-height: 500px;\n  // flex-wrap: nowrap;\n}\n\n.scrollModel {\n  max-height: 350px;\n  min-height: 350px;\n  height: 100%;\n  width: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0 10px;\n  border: none;\n}\n\n.nameModel h2 {\n  margin-left: 2%;\n  color: #21134f;\n  font-size: 24px;\n}\n.cardAllModel {\n  margin-top: 3%;\n}\n.edit {\n  display: none;\n}\n\n.notShow {\n  display: none;\n}\n\n.cardModel {\n  max-width: 330px;\n  min-height: 340px;\n}\n\n.textInput {\n  background-color: transparent;\n  border: 0;\n}\n\n.card-text {\n  display: flex;\n  width: 100% !important;\n  justify-content: center !important;\n  align-items: center;\n  gap: 10%;\n}\n\n.left-model,\n.right-model {\n  width: 50%;\n}\n\n.left-model {\n  float: left;\n  margin-left: 5%;\n}\n\n.right-model {\n  display: flex;\n  float: right;\n  margin-left: 31%;\n}\n\n.btn-model {\n  float: right;\n  margin-left: 5%;\n  color: #b7b7b7;\n}\n\n.model-action {\n  color: #b7b7b7;\n}\n\n.notShowInput {\n  display: none;\n}\n\n.showInput {\n  display: flex;\n  width: 100%;\n  text-align: center;\n}\n\n.newAdd {\n  background-color: transparent;\n  border: 0;\n}\n\n.inputModal {\n  display: flex;\n  margin-left: 6%;\n}\n\n.modelTag {\n  border: 0;\n  font-size: 15px;\n  border-radius: 8px;\n  width: 230px;\n  height: 30px;\n  text-align: center;\n  padding-top: 3%;\n}\n\n.nameModel h2 {\n  margin-left: 2%;\n  color: #21134f;\n  font-size: 20px;\n}\n.cardAllEdit {\n  margin-top: 3%;\n}\n.edit {\n  display: none;\n}\n\n.notShow {\n  display: none;\n}\n\n.cardEdit {\n  max-width: 330px;\n  min-height: 340px;\n}\n\n.textInput {\n  background-color: transparent;\n  border: 0px;\n}\n\n.left {\n  width: fit-content;\n  // float: left;\n  // margin-left: 5%;\n}\n\n.right {\n  display: flex;\n  overflow-wrap: normal;\n  margin-left: 0 !important;\n}\n\n.btn {\n  float: right;\n  margin-left: 5%;\n  color: #989898;\n}\n\n.notShowInput {\n  display: none;\n}\n\n.showInput {\n  display: flex;\n  width: 100%;\n  text-align: center;\n}\n\n.newAdd {\n  background-color: transparent;\n  border: 0;\n}\n\n.editScenario {\n  border: 0;\n  font-size: 15px;\n  border-radius: 8px;\n  width: 220px;\n  height: 35px;\n  text-align: center;\n  padding-top: 3%;\n}\n\n.scrollEditScenario {\n  height: 250;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0 10px;\n  border: none;\n}\n\n@media screen and (max-width: 1400px) {\n  .card-container > .ant-card-body{\n    padding: 24px 10px 10px 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
